// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"522":"9e445bc0","553":"fbd7b822"}[chunkId] + ".chunk.css";
};